export const validation = {
  name_es: 'required|min:1|max:100',
  status_id: 'required|numeric|min_value:1|max:2'
}

export const fields = function () {
  return {
    name_es: null,
    cover: null,
    status_id: null
  }
}

export const statusList = [
  {
    id: 1,
    name: 'Activo'
  },
  {
    id: 2,
    name: 'Inactivo'
  }
]

export const texts = {
  postCategoryEdit: {
    title: 'Editar Categoría Existente',
    subtitle: 'Edita la información de la categoría.',
    submit: 'Actualizar Categoría',
    messages: {
      success: {
        title: 'CATEGORÍA ACTUALIZADA',
        text: 'Esta categoría ha sido actualizada correctamente'
      }
    }
  },
  postCategoryNew: {
    title: 'Añadir Nueva Categoría',
    subtitle: 'Crear nueva categoría',
    submit: 'Crear Categoría',
    messages: {
      success: {
        title: 'CATEGORÍA CREADA',
        text: 'Se ha creado correctamente la neva Categoría'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/post_categories/mocks.js